import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';
import { IntegrationStateService } from '../../business-settings/integrations-settings/integration-state.service';
@Injectable({
  providedIn: 'root'
})
export class AppRegistryServiceService {

  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private integrationState: IntegrationStateService,
  ) {

  }

  private previousReturnUrl: string | null = null;

  setReturnUrl(url: string | null) {
    if (url && !url.includes('/admin/app-registry')) {
      this.previousReturnUrl = url;
    }
  }

  getReturnUrl(): string | null {
    return this.previousReturnUrl;
  }

  clearReturnUrl() {
    this.previousReturnUrl = null;
  }
  // filterDialog(componentName: any, panelClass: string, height: any, width: any, data: any, maxWidth: string = '95vw', maxHeight: string = '90vh') {
  //   return this.dialog.open(componentName, {
  //     panelClass: panelClass,
  //     height: height,
  //     width: width,
  //     data: data,
  //     maxWidth: maxWidth,
  //     maxHeight: maxHeight
  //   });
  // }

  openDialog(componentName: any, height: any, width: any, maxWidth: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      maxWidth: maxWidth,
      data: dataModel,
      disableClose: true,
      position: { right: '0px', top: '0px' },
    });
  }

  getApps(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/master/apps/filter`,
      data
    );
  }

  getBusinessFunctionData(){
    return this.http.get(
      environment.serverIp + `master/apps/get/function`
    );
  }

  getInstallStatus(data: any, businessId: any, appId: any){
    return this.http.put(
      environment.baseBusinessUrl + `business/toggle-app?businessId=${businessId}&appId=${appId}`, data
    );
  }

  getInstalledApps(businessId: any){
    return this.http.get(
      environment.baseBusinessUrl + `business/get-apps?businessId=${businessId}`
    );
  }

  getAllApps() {
    return this.http.get(
      environment.baseUrl + `app/app/list`
    )
  }

  getMyApps() {
    const businessId = localStorage.getItem('businessId');
    return this.http.get(
      environment.baseUrl + `app/app/business?businessId=${businessId}`
    )
  }

  installApp(appId: string) {
    const businessId = localStorage.getItem('businessId');
    return this.http.post(
      environment.baseUrl + `app/app/subscribe?appId=${appId}&businessId=${businessId}`, ''
    ).pipe(tap(() => this.integrationState.invalidate()));
  }

  unInstallApp(appId: string) {
    const businessId = localStorage.getItem('businessId');
    return this.http.delete(
      environment.baseUrl + `app/app/unsubscribe?appId=${appId}&businessId=${businessId}`
    ).pipe(tap(() => this.integrationState.invalidate()));
  }

  getCategoryApps(){
    return this.http.get(
      environment.baseUrl + `app/app/app-category`
    )
  }

  getAppDetails(appId: string){
    return this.http.get(
      environment.baseUrl + `app/app/explore-app/${appId}`
    )
  }
}
